import { connect } from 'react-redux';
import { alertWarningPaymentMethodHide } from 'modules/alert-module';
import AlertWarningPaymentMethodView from './alert-warning-payment-method-view';

export const mapDispatchToProps = {
  handleAlertDismiss: alertWarningPaymentMethodHide
};

export default connect(null, mapDispatchToProps)(AlertWarningPaymentMethodView);
